/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { GlobalConfigLang } from '@/model/global/GlobalSettings'

const entity = {
  currentName: {
    displayName: 'name'
  },
  amount: {},
  price: {},
  totalPrice: {}
}
const config = {
  load: async function (filter) {
    const [startDate, endDate] = filter[0].dateFilter
    const res = (await hillo.get('DashboardData.php', {
      showAttributeSales: 1,
      startDate,
      endDate,
      lang: GlobalConfigLang.lang
    }))?.attributeSales.filter(it => it.currentName || it.amount) ?? []
    res.forEach(it => {
      it.price = (it.totalPrice / it.amount).toFixed(2) ?? 0
    })
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)
